import { render } from "./ProductTypes.vue?vue&type=template&id=8d026a46&scoped=true"
import script from "./ProductTypes.vue?vue&type=script&lang=js"
export * from "./ProductTypes.vue?vue&type=script&lang=js"

import "./ProductTypes.vue?vue&type=style&index=0&id=8d026a46&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d026a46"]])

export default __exports__